module.exports = __webpack_public_path__ + "img/Fond_Carte_Anar_XXL_Neutre.554d926c.png";